import { render, staticRenderFns } from "./BlmJgyrender.vue?vue&type=template&id=6fdb16d4&scoped=true"
import script from "./BlmJgyrender.vue?vue&type=script&lang=js"
export * from "./BlmJgyrender.vue?vue&type=script&lang=js"
import style0 from "./BlmJgyrender.vue?vue&type=style&index=0&id=6fdb16d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdb16d4",
  null
  
)

export default component.exports